import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Api from '../../../services/Api';

const CharacteristicsSelector = ({
  onChanged,
  isMulti,
  selectedIds,
}) => {
  const [characteristics, setCharacteristics] = useState([]);

  useEffect(() => {
    Api.get('instances/building-characteristics?per_page=200').then((response) => {
      if (response.status === 200) {
        const mappedValues = response.data.data.map(product => ({
          label: `${product.name} [${product.code}]`,
          value: product.id,
        }));
        setCharacteristics(mappedValues);
      }
    });
  }, []);
  let selectedItems;
  if (selectedIds && selectedIds.length > 0) {
    selectedItems = characteristics.filter(x => selectedIds.includes(x.value));
  }
  return (
    <Select
      isMulti={isMulti}
      options={characteristics}
      value={selectedItems}
      onChange={(value) => {
        if (onChanged) {
          onChanged(value);
        }
      }}
      placeholder="Select Characteristic"
    />
  );
};

CharacteristicsSelector.propTypes = {
  onChanged: PropTypes.func,
  isMulti: PropTypes.bool,
  selectedIds: PropTypes.array,
};

CharacteristicsSelector.defaultProps = {
  onChanged: undefined,
  isMulti: false,
  selectedIds: undefined,
};

export default CharacteristicsSelector;
